var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{attrs:{"duration":2000,"width":300,"max":3,"animation-name":"fade-right","position":"top left"}})}
var staticRenderFns = []

export { render, staticRenderFns }